import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'

import api from 'core/api'

const getType = type => `@users/current/promotokens/address/${type}`

export const getPromoTokensAddress = createActionThunk(
  getType('FETCH'),
  api('/users/current/promotokens/address')
)

export const generatePromoTokensAddressThunk = createActionThunk(
  getType('GENERATE'),
  api('/users/current/promotokens/address', { method: 'POST' })
)

export const generatePromoTokensAddress = () => dispatch => {
  dispatch(generatePromoTokensAddressThunk()).catch(res =>
    dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
  )
}

const initialState = {}

export default handleActions(
  {
    [getPromoTokensAddress.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getPromoTokensAddress.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [generatePromoTokensAddressThunk.START]: state => ({ ...state, loading: true }),
    [generatePromoTokensAddressThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [generatePromoTokensAddressThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [generatePromoTokensAddressThunk.ENDED]: state => ({ ...state, loading: false })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/current/promotokens/address.js